export default __webpack_public_path__ + "static/media/190629_190332_IMG_2688.97833323.jpg";